import { type ReactNode } from "react";

interface ListGroupItemProps {
  children: ReactNode;
}

export default function ListGroupItem({ children }: ListGroupItemProps) {
  return (
    <li className="relative block border-zinc-200 px-4 py-2 dark:border-zinc-600 dark:text-zinc-200">
      {children}
    </li>
  );
}
